import transformerRelance from '@/services/relances/filter/relancesServerTableDataTransformer';
import HTTP from '../HTTP';

const URL_BASE = 'gescom/Relance/';

export async function getTexte(params) {
  const response = await HTTP.post(URL_BASE + 'PGetTexteAsync', params);
  return response;
}

export async function getByMouvementClient(params) {
  const response = await HTTP.post(URL_BASE + 'PGetByMouvementClientAsync', params);
  return response;
}

export async function create(relance) {
  const response = await HTTP.post(URL_BASE + 'CreateAsync', relance);
  return response;
}

export async function get(id) {
  const response = await HTTP.get(URL_BASE + 'GetAsync', { params: { id: id } });
  return response;
}

export async function update(relance) {
  const response = await HTTP.put(URL_BASE + 'UpdateAsync', relance);
  return response;
}

export async function getAll(relanceFilter) {
  const inputServer = transformerRelance(relanceFilter);
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', inputServer);
  return response;
}

export async function sendEmailRelance(object) {
  const response = await HTTP.post(URL_BASE + 'MailAsync', object);
  return response;
}

export async function updateEtat(payload) {
  const response = await HTTP.post(URL_BASE + 'ChangerEtatAsync', payload);
  return response;
}

export async function deleteAll(data) {
  const response = await HTTP.post(URL_BASE + 'PDeleteAllAsync', data);
  return response;
}

export async function archiver(ids, status) {
  const response = await HTTP.post(URL_BASE + 'ArchiverAsync', { ids: ids, archiver: status });
  return response;
}

export async function commenter(payload) {
  const response = await HTTP.post(URL_BASE + 'CommenterAsync', payload);
  return response;
}
